// extracted by mini-css-extract-plugin
export default {"root":"SearchBasicTable_root__3jVkb","iconButton":"SearchBasicTable_iconButton__wenjq","divider":"SearchBasicTable_divider__NZNxS"};